import {all, fork, take} from 'redux-saga/effects';
import {watchQCToolsArtwork} from 'QCTools/QCToolsArtwork/Redux/saga';
import watchTargetAge from '@pluto/target-age/Redux/saga';
import watchSnapshot from '../VideoAudioQC/QCTabs/Snapshots/Redux/saga';
import watchDeliveryManagerManifest from '../QCWorkflow/DeliveryManager/DeliveryManagerManifest/Redux/saga';
import {LOGIN_START, LOGOUT_START} from '../Login/Redux/LoginActions';
import {watchContentItemWorkHistory} from '../ContentItemView/ContentItemViewWorkHistory/Redux/saga';
import {watchContentItemViewArtwork} from 'ContentItemView/ContentItemViewArtwork/Redux/saga/watchers';
import {watchContentItemViewMetadata} from '../ContentItemView/ContentItemViewMetadata/Redux/saga';
import {login, logout} from './workers';

export function* watchAuth() {
    const {jwt} = yield take(LOGIN_START);
    yield fork(login, jwt);

    yield take(LOGOUT_START);
    yield fork(logout);
}

export default function* rootSaga() {
    yield all([
        fork(watchTargetAge),
        fork(watchAuth),
        fork(watchSnapshot),
        fork(watchContentItemWorkHistory),
        fork(watchQCToolsArtwork),
        fork(watchContentItemViewArtwork),
        fork(watchContentItemViewMetadata),
        fork(watchDeliveryManagerManifest),
    ]);
}
